import React, { createContext, useReducer } from "react";
import { reducer } from "./Reducer";

export const GlobalContext = createContext("Initial Value");

let data = {
  clickLoad: false,
  darkTheme: true,
  user: {},
  ramzanPopup: {},
  isLogin: null,
  token: "",
  ipAddress: "",
  reloadTime: null,
  reloadToggle: false,
  baseUrl:
    window.location.href.split(":")[0] == "https"
      ? "https://crm.opraviq.com/backend/api"
      : "https://crm.opraviq.com/backend/api", // http://192.168.100.101/Opraviq-CRM-backend/api //192.168.100.109 // http://192.168.100.102/Opraviq-CRM-backend/api
  mainPageLoad: false,
  basePath: "",
  userList: [],
  getDropdowns: {},
  ModalData: {},
  timeIn: "",
  timeOut: "",
  hrs: "",
  timeLoader: false,
  coverPhotos: [],
  // basePath: "/new-dashboard" //For Live
};

export default function ContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, data);
  const reloadSetTime = () => {
    dispatch({ type: "UPDATE_RELOAD_TIME" });
  };
  return (
    <GlobalContext.Provider value={{ state, dispatch, reloadSetTime }}>
      {children}
    </GlobalContext.Provider>
  );
}
